import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { apiMethod, apiType, API_URL } from 'utils';
import OrderManagementApiService from './OrderManagementApiService';
import { IPayload } from 'Model/IPayload';
import { GET_ADDITIONAL_APPROVAL_LIST_ASSIGNMENT, GET_All_APPROVAL_LIST_EXCEL_DATA, GET_APPROVAL_LIST_ASSIGNMENT, GET_APPROVAL_LIST_EXCEL_DATA, SAVE_APPROVAL_LIST_ASSIGNMENT, VALIDATE_APPROVAL_LIST_ASSIGNMENT } from 'Store/OrderManagement/ApprovalListAssignment/ApprovalListAssignmentType';
import { setAdditionalApprovalListAssignment, setAllApprovalListExcelData, setApprovalListAssignment, setApprovalListExcelData, setIsApprovalListSaved, setIsApprovalListValidated } from 'Store/OrderManagement/ApprovalListAssignment/ApprovalListAssignmentAction';

function* getApprovalAssignment(req?: any): any {

    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.OrderManagement,
        endpoint: `hierarchy/approval/${req?.payload.entityId }/${req?.payload?.entityType}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching grid details...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setApprovalListAssignment(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setApprovalListAssignment(null))
        yield put(globalLoaderText(""));
    }
}

function* getAdditionalApprovalListAssignment(req?: any): any {

    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.OrderManagement,
        endpoint: `hierarchy/approval/${req?.payload.entityId }/${req?.payload?.entityType}?isAdditionalApprover=true`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching grid details...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setAdditionalApprovalListAssignment(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setAdditionalApprovalListAssignment(null))
        yield put(globalLoaderText(""));
    }
}

function* saveApprovalList(req?: any): any {

    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.OrderManagement,
        endpoint: `hierarchy/approval/assignment`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Saving Approval List Assignment...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setIsApprovalListSaved(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setIsApprovalListSaved(false))
        yield put(globalLoaderText(""));
    }
}

function* validateApprovalList(req?: any): any {

    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.OrderManagement,
        endpoint: `hierarchy/approval/validate`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Validating Approval List Assignment...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setIsApprovalListValidated({...response, isError : false}));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setIsApprovalListValidated({isError : true}))
        yield put(globalLoaderText(""));
    }
}

function* getApprovalListExcel(req?: any): any {

    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.OrderManagement,
        endpoint: `hierarchy/approval/approvallist/export/${req?.payload.entityId }/${req?.payload?.entityType}?isAdditionalApprover=${req?.isAdditionalApprover || false}`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Fetching Approval List Assignment...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setApprovalListExcelData(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setApprovalListExcelData(""))
        yield put(globalLoaderText(""));
    }
}

function* getAllApprovalListExcel(req?: any): any {

    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.OrderManagement,
        endpoint: `hierarchy/approval/approvallist/exportAll?isAdditionalApprover=${req?.isAdditionalApprover || false}`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Fetching All Approval List Assignment...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setAllApprovalListExcelData(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setAllApprovalListExcelData(""))
        yield put(globalLoaderText(""));
    }
}

function* watchApprovalListAssignment() {
    yield takeEvery(GET_APPROVAL_LIST_ASSIGNMENT, getApprovalAssignment);
    yield takeEvery(GET_ADDITIONAL_APPROVAL_LIST_ASSIGNMENT, getAdditionalApprovalListAssignment);
    yield takeEvery(SAVE_APPROVAL_LIST_ASSIGNMENT, saveApprovalList);
    yield takeEvery(VALIDATE_APPROVAL_LIST_ASSIGNMENT, validateApprovalList);
    yield takeEvery(GET_APPROVAL_LIST_EXCEL_DATA, getApprovalListExcel);
    yield takeEvery(GET_All_APPROVAL_LIST_EXCEL_DATA,getAllApprovalListExcel)
}

export default function* combinedSaga() {
    yield all([
        watchApprovalListAssignment()
    ])
}
